module.exports = {"data":{"page":{"id":"/opt/build/repo/content/pages/success/index.md absPath of file >>> MarkdownRemark","html":"<p>Thank you. <br />\nI will answer to your message as soon as possible.</p>","frontmatter":{"title":"Success"}},"site":{"siteMetadata":{"facebook":{"appId":"885294908345276"}}}},"pathContext":{"slug":"/success/"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/success.json
// module id = 777
// module chunks = 170786371021445